import React, { useEffect, useState, useCallback } from 'react';
import QRCode from 'qrcode';

interface QRCodeDisplayProps {
  galleryId: string;
}

export const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ galleryId }) => {
  const [canvas, setCanvas] = useState<HTMLCanvasElement | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [uploadUrl, setUploadUrl] = useState<string>('');

  const canvasRef = useCallback((node: HTMLCanvasElement | null) => {
    console.log('Canvas ref callback called with:', node);
    setCanvas(node);
  }, []);

  useEffect(() => {
    console.log('QRCodeDisplay effect running, canvas:', canvas, 'galleryId:', galleryId);
    
    const generateQRCode = async () => {
      if (!canvas) {
        console.log('No canvas available yet');
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const url = `${window.location.origin}/gallery/${galleryId}/upload`;
        setUploadUrl(url);
        console.log('Generating QR code for URL:', url);
        
        await QRCode.toCanvas(canvas, url, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        console.log('QR code generated successfully');
        setLoading(false);
      } catch (err) {
        console.error('QR code generation failed:', err);
        setError('Failed to generate QR code');
        setLoading(false);
      }
    };

    if (canvas) {
      generateQRCode();
    }
  }, [canvas, galleryId]);

  console.log('QRCodeDisplay rendering, loading:', loading, 'error:', error, 'canvas:', !!canvas);

  return (
    <div className="flex flex-col items-center space-y-2">
      <div className="w-[200px] h-[200px] bg-muted rounded-lg border flex items-center justify-center relative">
        {loading && (
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
        )}
        {error && (
          <span className="text-sm text-muted-foreground text-center px-4">
            {error}
          </span>
        )}
        <canvas
          ref={canvasRef}
          className={`rounded-lg bg-white ${loading || error ? 'hidden' : ''}`}
          width={200}
          height={200}
          style={{ width: '200px', height: '200px' }}
        />
      </div>
      <p className="text-xs text-muted-foreground text-center max-w-[200px]">
        Scan with your phone to upload photos
      </p>
      {process.env.NODE_ENV === 'development' && (
        <p className="text-xs text-muted-foreground text-center max-w-[200px] font-mono break-all">
          {uploadUrl}
        </p>
      )}
    </div>
  );
};
